export const header = function( $scope ) {

    $scope.showDropdownFlag = false;
    $scope.currentlyHovered = '';
    
    $scope.showDropdown = (currentlyHovered) => {
        
        $scope.currentlyHovered = currentlyHovered;
        $scope.showDropdownFlag = true;
    };

    $scope.checkIfHovered = (value) => {
        return $scope.currentlyHovered == value;
    };
};